import React,{ useCallback, useState, useLayoutEffect, Suspense } from 'react'
import { ReactLenis, useLenis } from 'lenis/react'
import {useNavigation, ScrollRestoration, useLocation} from "react-router-dom"

import { Header } from '../components/Layout/Header';
import { Footer } from '../components/Layout/Footer';
import { Loading } from '../components/Layout/Loading';
import { SocialSlider } from '../components/Layout/SocialSlider';
import { Enquire } from '../components/Layout/Enquire';
import { Outlet } from 'react-router-dom';
import { useAppContext } from "../Context/Store";
 

const Wrapper = ({children}) => {
  const location = useLocation();
  const lenis = useLenis();

  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
    lenis?.scrollTo(0, { immediate: true });
  }, [location.pathname, lenis]);
  return children
} 
export default function AppLayout() {

  const { isError, isLoading, HomeData } = useAppContext(); 

    let navigation = useNavigation();

    const [childData, setChildData] = useState(false);

    // Function to receive data from child
    const handleChildData = (data) => {
      setChildData(data);
      //console.log("Child Event", data);
    };
    // const getKey = useCallback(
    //     (location, matches) => {
    //       let match = matches.find((m) => m.handle?.scrollMode);
    //       if (match?.handle?.scrollMode === "pathname") {
    //         return location.pathname;
    //       }
      
    //       return location.key;
    //     },
    //     []
    //   );

      if(navigation.state === "loading") return <Loading />;

      
      const { properties } = HomeData;

      //console.log("Social Feed", properties);

  return (
    <> 


{/* <ScrollRestoration getKey={getKey} /> */}
    <ReactLenis root>
    
<Wrapper>
      <Header onSendData={handleChildData} />
      <main> 
            <Outlet context={handleChildData}></Outlet>
            {/* <Routes>
              <Route path="/" exact element={<Home />} />
              <Route path="our-collection" exact element={<OurCollections />} />
              <Route path="our-collection/:id" exact element={<CategorieDetails />} />
              <Route path="customized" exact element={<h2>Customized</h2>} />
              <Route path="about-us" exact element={<h2>About us</h2>} />
              <Route path="contact" exact element={<h2>Contact</h2>} />
              <Route path="*" element={<h2>Page not found</h2>} />
            </Routes> */}
            <SocialSlider SocialFeedheadingDataDynamic={properties?.heading} SocialFeedItemsDataDynamic={properties?.socialFeedItems?.items} FollowUsTextDataDynamic={properties?.followUsText} /> 
            <Enquire trigger={childData} setTrigger={setChildData} />
        </main>
      <Footer onSendData={handleChildData} /></Wrapper>
    </ReactLenis>
 
    </>
  )
}
